import { Component, inject, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TransferPartnerDTO } from 'src/app/models/TransferPartnerDTO.model';
import { UserDTO } from 'src/app/models/UserDTO.model';
import { UserGroupDTO } from 'src/app/models/UserGroupDTO.model';
import { UserPartnerDTO } from 'src/app/models/UserPartnerDTO.model';
import { DistributorsService } from 'src/app/services/distributors.service';
import { Alert } from 'src/app/shared/models/Alert';
import { ResponseDataFile } from 'src/app/shared/models/ApiResponse';
import { SimpleRequestDTO } from 'src/app/shared/models/SimpleRequest';
import { AlertService } from 'src/app/shared/services/alert.service';
import { saveAs } from 'file-saver';

import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SearchPipe } from '../../../pipes/search.pipe';
import { SearchModalPipe } from '../../../pipes/search-modal.pipe';
import { ValidatePermissionsService } from '../../../shared/services/validate-permissions.service';

@Component({
    selector: 'app-list-distributor-partners',
    templateUrl: './list-distributor-partners.component.html',
    styleUrls: ['./list-distributor-partners.component.css'],
    imports: [CommonModule, FormsModule, SearchPipe, SearchModalPipe]
})
export class ListDistributorPartnersComponent {
  @Input() distributorDataInput: UserDTO = {} as UserDTO;

  partners: UserPartnerDTO[] = [];
  partnersAssigned: UserPartnerDTO[] = [];
  partnersAvailables: UserPartnerDTO[] = [];
  distributorsAvailables: TransferPartnerDTO[] = [];

  originalPartners: UserPartnerDTO[] = [];
  originalPartnersAvailables: UserPartnerDTO[] = [];
  originalDistributorsAvailables: TransferPartnerDTO[] = [];

  recordsPerPage: number = 10;
  currentPage: number = 1;
  currentPageAvailables: number = 1;
  currentPageDistributorAvailables: number = 1;
  totalPages: number = 0;
  totalPagesAvailables: number = 0;
  totalPagesDistributorAvailables: number = 0;
  pagesToShow: number = 5;

  textoBusqueda: string = '';
  textoBusquedaAssignPartner: string = '';
  textoBusquedaTransferPartner: string = '';

  camposBusqueda: string[] = ['customerAccount', 'userNames', 'userMail', 'userPhone', 'numberPlans'];
  camposBusquedaAvailables: string[] = ['idPartner', 'namePartner', 'mailPartner', 'phone', 'totalCustomers'];

  isFilteredByStatus: boolean = false;
  isAnyCheckboxSelected: boolean = false;
  isAnyCheckboxSelectedPartnerCustomer: boolean = false;
  isAnyCheckboxSelectedTransfer: boolean = false;

  simpleRequestDTO: SimpleRequestDTO = {} as SimpleRequestDTO;
  alert: Alert = {} as Alert;

  public permissionsService = inject(ValidatePermissionsService);
  private distributorsService = inject(DistributorsService);
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private alertService = inject(AlertService);

  
  ngOnInit() {
    this.simpleRequestDTO.id = this.distributorDataInput.userId;

    this.distributorsService.getListPartnersByDistributorId(this.simpleRequestDTO).subscribe(
      ({ StatusCode, Message, Data }) => {
        if (Data != null) {
          this.handleGetListPartners(Data);
        } else {
          this.handleMessageError(StatusCode);
        }
      },
      () => { this.handleMessageError(0); }
    );

    this.distributorsService.getAllDistributorsAvailables().subscribe(
      ({ StatusCode, Message, Data }) => {
        if (Data != null) {
          this.handleGetAllDistributorsAvailables(Data);
        } else {
          this.handleMessageError(StatusCode);
        }
      },
      () => { this.handleMessageError(0); }
    );
  }

  get pages(): number[] {
    const start = Math.max(1, this.currentPage - Math.floor(this.pagesToShow / 2));
    const end = Math.min(this.totalPages, start + this.pagesToShow - 1);
    return Array.from({ length: end - start + 1 }, (_, i) => start + i);
  }

  get pageAvailables(): number[] {
    const start = Math.max(1, this.currentPageAvailables - Math.floor(this.pagesToShow / 2));
    const end = Math.min(this.totalPagesAvailables, start + this.pagesToShow - 1);
    return Array.from({ length: end - start + 1 }, (_, i) => start + i);
  }

  get pageDistributorAvailables(): number[] {
    const start = Math.max(1, this.currentPageDistributorAvailables - Math.floor(this.pagesToShow / 2));
    const end = Math.min(this.totalPagesDistributorAvailables, start + this.pagesToShow - 1);
    return Array.from({ length: end - start + 1 }, (_, i) => start + i);
  }

  changePage(page: number) { if (page >= 1 && page <= this.totalPages) this.currentPage = page; }
  changePageAvailables(page: number) { if (page >= 1 && page <= this.totalPagesAvailables) this.currentPageAvailables = page; }
  changePageDistributorAvailables(page: number) { if (page >= 1 && page <= this.totalPagesDistributorAvailables) this.currentPageDistributorAvailables = page; }

  previousPage() { if (this.currentPage > 1) this.currentPage--; }
  previousPageAvailables() { if (this.currentPageAvailables > 1) this.currentPageAvailables--; }
  previousPageDistributorAvailables() { if (this.currentPageDistributorAvailables > 1) this.currentPageDistributorAvailables--; }

  nextPage() { if (this.currentPage * 10 < this.partners.length) this.currentPage++; }
  nextPageAvailables() { if (this.currentPageAvailables * 10 < this.partnersAvailables.length) this.currentPageAvailables++; }
  nextPageDistributorAvailables() { if (this.currentPageDistributorAvailables * 10 < this.distributorsAvailables.length) this.currentPageDistributorAvailables++; }

  handleMessageError(StatusCode: number) {
    this.alert = { alertMessage: 'Unexpected error. Please try again later.', alertType: 'alert alert-danger', alertCenter: false, alerTitle: '', duration: 3000 };
    this.alertService.updateAlertState(this.alert);
  }

  handleGetListPartners(users: UserPartnerDTO[]) {
    this.partners = users;
    this.partnersAssigned = users.map(u => ({ ...u }));
    this.originalPartners = this.partners.slice();
    this.partners = this.originalPartners.filter(p => p.userStatus === 0 || p.userStatus === 1);
    this.totalPages = Math.ceil(this.partners.length / 10);

    this.distributorsService.getListPartnersAvailables().subscribe(
      ({ StatusCode, Message, Data }) => {
        if (Data != null) {
          this.handleGetListPartnersAvailables(Data);
        } else {
          this.handleMessageError(StatusCode);
        }
      },
      () => { this.handleMessageError(0); }
    );
  }

  handleGetListPartnersAvailables(users: UserPartnerDTO[]) {
    this.partnersAvailables = users.map(u => ({ ...u }));
    this.partnersAssigned.forEach(p => { p.checked = true; });
    this.partnersAvailables = this.partnersAvailables.concat(this.partnersAssigned.map(p => ({ ...p })));
    this.originalPartnersAvailables = this.partnersAvailables.slice();
    this.partnersAvailables = this.originalPartnersAvailables.filter(p => p.userStatus === 0 || p.userStatus === 1);
    this.totalPagesAvailables = Math.ceil(this.partnersAvailables.length / 10);
  }

  handleGetAllDistributorsAvailables(distributors: TransferPartnerDTO[]) {
    this.distributorsAvailables = distributors.filter(d => d.idPartner !== this.distributorDataInput.userId);
    this.originalDistributorsAvailables = this.distributorsAvailables.slice();
    this.totalPagesDistributorAvailables = Math.ceil(this.distributorsAvailables.length / 10);
  }

  updatePagination(): void {
    const searchCriteria = this.textoBusqueda.split(',').map(c => c.trim().toLowerCase());
    const filteredList = this.partners.filter(item =>
      this.camposBusqueda.some(field => {
        const val = (item as any)[field];
        return val != null && searchCriteria.some(c => val.toString().toLowerCase().includes(c));
      })
    );
    this.totalPages = Math.ceil(filteredList.length / this.recordsPerPage);
    this.currentPage = 1;
  }

  onSearchChange(): void { this.updatePagination(); }
  onSearchChangeAvailables(): void {
    const searchCriteria = this.textoBusquedaAssignPartner.split(',').map(c => c.trim().toLowerCase());
    const filteredList = this.partnersAvailables.filter(item =>
      this.camposBusqueda.some(field => {
        const val = (item as any)[field];
        return val != null && searchCriteria.some(c => val.toString().toLowerCase().includes(c));
      })
    );
    this.totalPagesAvailables = Math.ceil(filteredList.length / this.recordsPerPage);
    this.currentPageAvailables = 1;
  }

  onSearchChangeDistributorAvailables(): void {
    const searchCriteria = this.textoBusquedaTransferPartner.split(',').map(c => c.trim().toLowerCase());
    const filteredList = this.distributorsAvailables.filter(item =>
      this.camposBusquedaAvailables.some(field => {
        const val = (item as any)[field];
        return val != null && searchCriteria.some(c => val.toString().toLowerCase().includes(c));
      })
    );
    this.totalPagesDistributorAvailables = Math.ceil(filteredList.length / this.recordsPerPage);
    this.currentPageDistributorAvailables = 1;
  }

  checkboxChanged(): void { this.isAnyCheckboxSelected = this.partnersAvailables.some(p => p.checked); }
  checkboxChangedPartnerCustomer(): void { this.isAnyCheckboxSelectedPartnerCustomer = this.partners.some(p => p.checked); }

  checkboxChangedTransfer(selected: TransferPartnerDTO): void {
    this.distributorsAvailables.forEach(d => d.checked = false);
    const found = this.distributorsAvailables.find(d => d === selected);
    if (found) found.checked = true;
    this.isAnyCheckboxSelectedTransfer = !!found;
  }

  selectAllCheckboxes(event: any): void {
    const checked = event.target.checked;
    this.partnersAvailables.forEach(p => p.checked = checked);
    this.isAnyCheckboxSelected = checked;
  }

  selectAllCheckboxesPartnerCustomer(event: any): void {
    const checked = event.target.checked;
    this.partners.forEach(p => p.checked = checked);
    this.isAnyCheckboxSelectedPartnerCustomer = checked;
  }

  assignPartners(confirmed: boolean) {
    if (confirmed) {
      const listUserGroup: UserGroupDTO[] = this.partnersAvailables.map(p => ({
        AUsrId: p.customerAccount,
        APartnerId: this.distributorDataInput.userId,
        Checked: p.checked
      }));

      this.distributorsService.addPartnersDistributor(listUserGroup).subscribe(
        ({ Data }) => {
          if (Data != null) {
            this.handleAssignSuccess(Data);
          } else {
            this.handleMessageError(0);
          }
        },
        () => { this.handleMessageError(0); }
      );
    }
  }

  transferPartners(confirmed: boolean) {
    if (confirmed) {
      const selectedDistributor = this.distributorsAvailables.find(d => d.checked);
      const listUserGroup: UserGroupDTO[] = this.originalPartners
        .filter(p => p.checked)
        .map(p => ({
          AUsrId: p.customerAccount,
          APartnerId: selectedDistributor?.idPartner
        }));

      this.distributorsService.updatePartnersDistributor(listUserGroup).subscribe(
        ({ Data }) => {
          if (Data != null) {
            this.handleTransferSuccess(Data);
          } else {
            this.handleMessageError(0);
          }
        },
        () => { this.handleMessageError(0); }
      );
    }
  }

  handleAssignSuccess(result: boolean) {
    this.alert = { alertMessage: 'Partners assigned successfully', alertType: 'alert alert-success', alertCenter: false, alerTitle: '', duration: 3000 };
    this.alertService.updateAlertState(this.alert);
    this.ngOnInit();
  }

  handleTransferSuccess(result: boolean) {
    this.alert = { alertMessage: 'Partners transferred successfully', alertType: 'alert alert-success', alertCenter: false, alerTitle: '', duration: 3000 };
    this.alertService.updateAlertState(this.alert);
    this.ngOnInit();
  }

  exportToExcelListDistributorPartners() {
    this.distributorsService.exportToExcelListDistributorPartners(this.simpleRequestDTO).subscribe(
      (response: ResponseDataFile) => {
        if (response) {
          const byteCharacters = atob(response.Data.fileContents);
          const byteNumbers = Array.from({ length: byteCharacters.length }, (_, i) => byteCharacters.charCodeAt(i));
          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], { type: response.Data.contentType });
          saveAs(blob, response.Data.fileDownloadName || 'export.xlsx');
          this.alert = { alertMessage: 'File generated successfully', alertType: 'alert alert-success', alertCenter: false, alerTitle: '', duration: 3000 };
          localStorage.setItem('AlertObject', JSON.stringify(this.alert));
          this.alertService.updateAlertState(this.alert);
        } else {
          this.handleMessageError(0);
        }
      },
      (error) => { console.error('Error exporting Excel:', error); }
    );
  }


  public navigateToPartner(partner: UserPartnerDTO) {
    // Только если есть доступ к Partners
    if (this.permissionsService.partners.readPermission || this.permissionsService.partners.editPermission) {
      const user = <UserDTO>{
        userId: partner.customerAccount,
        userNames: partner.userNames
      };
      if (this.permissionsService.partners.editPermission) {
        this.router.navigate(['/partners/partner-customers'],
          {
            relativeTo: this.route,
            state: { partnerData: user },
          });
      } else {
        // для readonly режима - на другой роут
        this.router.navigate(['/partners/view-partner', partner.customerAccount]);
      }
    }
  }
}
